type Level = 'silent' | 'error' | 'warn' | 'info' | 'debug'

const LOG_LEVEL = (
  process.env.LOG_LEVEL || (process.env.NODE_ENV === 'production' ? 'info' : 'debug')
).toLowerCase() as Level
const AI_DEBUG = String(process.env.LOG_AI_DEBUG || '').toLowerCase() === 'true'

function levelToNum(l: Level): number {
  switch (l) {
    case 'silent':
      return 99
    case 'error':
      return 40
    case 'warn':
      return 30
    case 'info':
      return 20
    case 'debug':
      return 10
    default:
      return 20
  }
}

const current = levelToNum(LOG_LEVEL)

function redact(msg: any): any {
  try {
    const str = typeof msg === 'string' ? msg : JSON.stringify(msg)
    return str
      .replace(/(sk-[A-Za-z0-9_-]{8,})/g, 'sk-***')
      .replace(/(Bearer\s+)[A-Za-z0-9._-]+/gi, '$1***')
      .replace(/("apiKey"\s*:\s*")[^"]+(")/gi, '$1***$2')
  } catch {
    return '[unserializable]'
  }
}

function log(kind: 'log' | 'warn' | 'error', prefix: string, ...args: any[]) {
  const ts = new Date().toISOString()
  const out = args.map((a) => redact(a))
  console[kind](`[${ts}] ${prefix}`, ...out)
}

export const logger = {
  error: (...args: any[]) => {
    if (current <= levelToNum('error')) log('error', '[ERROR]', ...args)
  },
  warn: (...args: any[]) => {
    if (current <= levelToNum('warn')) log('warn', '[WARN ]', ...args)
  },
  info: (...args: any[]) => {
    if (current <= levelToNum('info')) log('log', '[INFO ]', ...args)
  },
  debug: (...args: any[]) => {
    if (AI_DEBUG || current <= levelToNum('debug')) log('log', '[DEBUG]', ...args)
  },
  truncate: (s: string, n = 200) => (s.length > n ? s.slice(0, n) + '…' : s),
}
